import { defineStore } from 'pinia';
import { useForm } from '@inertiajs/vue3';

import { Notify } from 'quasar';

import axios from 'axios';

axios.defaults.baseURL = import.meta.env.AXIOS_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export const useBulletinStore = defineStore('bulletinStore', {
    state: () => ({
        loaded: false,
        loading: false,
        data: [],
        depth: 1,
        count: 0,
        unread: 0,
        pagination: useForm({
            rowsPerPage: 10,
            cursor: null,
        }),
        cursor: {
            prev: null,
            next: null,
        },
    }),
    actions: {
        async fetch(cursor = null, append = false, forceFetch = false) {
            if (cursor) {
                this.pagination.cursor = cursor;
            }

            this.loading = true;

            const { data } = await axios.get(route('bulletin.index'), {
                params: this.pagination.data(),
            });
            
            if (append) {
                this.data = this.data.concat(data.data);
            } else {
                this.data = data.data;
            }

            this.cursor.next = data.next_cursor;
            this.cursor.prev = data.prev_cursor;

            this.count = data.count;
            this.unread = data.unread_count;

            this.loaded = true;
            this.loading = false;
        },
        async fetchCount() {
            const { data } = await axios.get(route('bulletin.unread-count'));
            
            this.unread = data.unread_count;
        },
        async fetchNext(append = false) {
            await this.fetch(this.cursor.next, append);

            this.depth++;
        },
        async fetchPrev(append = false) {
            await this.fetch(this.cursor.prev, append);

            this.depth--;
        },
    },
    getters: {
        paginationData() {
            return this.pagination.data();
        },
        loadMoreText() {
            if (this.loading) {
                return 'Loading...';
            }

            if (!this.cursor.next) {
                return 'No more bulletins to load';
            }
            
            const count = this.count - this.data.length;

            return `Load ${count > this.pagination.rowsPerPage ? this.pagination.rowsPerPage : count } more`;
        }
    },
});